import { useMemo } from "react";
import ServiceCard from "./ServiceCard";
import { Wrapper } from "../styles";
import { CustomDivider } from "../styles/Main.styled";

const OurServices = () => {
  const listOfServices = useMemo(
    () => [
      {
        title: "Serach Job",
        description: `You can find all translation jobs here. We
            provide easy search and many
            jobs suitable for you
           `,
        image: require("../../assets/icons/11235.svg").default,
      },
      {
        title: "Create a service",
        description: `Create the service you want easily, quickly and with high quality to start with us`,
        image: require("../../assets/icons/11238.svg").default,
      },
      {
        title: "post Job",
        description: `Post a job and find translators with a fast, secure connection and highly experienced professional`,
        image: require("../../assets/icons/11234.svg").default,
      },
    ],
    []
  );
  return (
    <Wrapper isCenter isSection>
      <div
        style={{
          margin: "3rem 0",
        }}
      >
        <h1>Our Services</h1>
        <CustomDivider isCenter colorAfter colorBefore />
      </div>
      <Wrapper hasColumns>
        {listOfServices.map((service, index) => (
          <ServiceCard data={service} />
        ))}
      </Wrapper>
    </Wrapper>
  );
};

export default OurServices;
